// GLOBAL VARIABLE SETUP
// =================================================================================================
// SCENES
import React from 'react';
import VideoComponent from './video';
import ResultComponent from './result';
import SplashComponent from './splash';
import MobileComponent from './mobile';
import WechatQRComponent from './wechat-qr';

// COMPONENT SPECIFIC IMAGES
import kawoLogo from '../images/KAWO-logo.png';
import burstBackground from '../images/burst-background.png';

// HELP FUNCTIONS
import '../utils/canvas-to-blob';
import '../utils/kawo-tooltip';

let gifshot = require( 'gifshot' ),
	getDegrees = require( '../utils/qtff-rotation' ).getRotation,
	tr = require( '../utils/translations' ).translate,
	src;

window.checkMobile = function () {
	let check = false;

	(function ( a ) {
		if ( /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test( a ) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test( a.substr( 0, 4 ) ) ) check = true;
	})( navigator.userAgent || navigator.vendor || window.opera );

	return check;
};


// MIXPANEL SET UP
// =================================================================================================
require( 'mixpanel-browser' );

// STAGING MIXPANEL TRACKING
if ( DEBUG ) window.mixpanel.init( "c29e77eef971a0012b261a446cc73c76", { debug: true } );

// PRODUCTION MIXPANEL TRACKING
else window.mixpanel.init( "d7708ff957424c3be414d3b28698d0af" );


// MAIN REACT CLASS DECLARATION
// =================================================================================================
class App extends React.Component {


	// REACT APP CONSTRUCTOR
	// =============================================================================================
	constructor( props ) {

		super( props );

		this.initialState = {
			frameRate: 12,
			sampleInterval: 1,
			images: [],
			saveFrames: true,
			canvasHeight: 0,
			canvasWidth: 0,
			tab: 1,
			imageQuality: 'medium',
			handleWidth: 0,
			videoCurrentTime: 0,
			videoStartTime: 0,
			videoEndTime: 0,
			handlePos: -15,
			tooltipInSeconds: 10
		};

		this.state = this.initialState;

		this.dragCounter = 0;

		window.mixpanel.track( 'Pageview', {
			app: 'video-to-gif',
			action: 'upload',
			lang: window.userLanguage || 'CN'
		} );

		window.mixpanel.track( 'App Loaded', {
			app: 'video-to-gif',
			lang: window.userLanguage || 'CN'
		} )
	}


	// MAIN RENDER METHOD
	// =============================================================================================
	render() {
		let logo, header, splash, upload, video, result,
			state = this.state,
			tab = state.tab,
			videoSrc = state.videoSource,
			gifSrc = state.gifSource,
			inBounds = state.inDropBounds,
			seenSplash = localStorage.getItem( 'visited' ) || state.seenSplash,
			showWeChatSplash = /MicroMessenger/.test( navigator.userAgent || navigator.vendor || window.opera ),
			error = state.error;

		// SHOW SPLASH SCREEN IF FIRST TIME USER VISITED
		if ( !seenSplash ) splash = <SplashComponent App={this}/>;

		// SHOW MOBILE SPLASH IF USER ON MOBILE DEVICE
		if ( checkMobile() && showWeChatSplash )
			splash = <MobileComponent App={this}/>;


		// LOGO SECTION ----------------------------------------------------------------------------
		logo = <div className="logo-container">

			<h3 data-id="1" onClick={( e ) => this.setTab( e )}>动次</h3>

			<a target="_blank" href="http://www.kawo.com">
				<div className="logo-inner">
					<small>{tr( 'made by', '技术提供' )}</small>
					<img src={kawoLogo}/>
				</div>
			</a>
		</div>;


		// NORMAL VIEW HEADER SECTION
		// -----------------------------------------------------------------------------------------
		header = <div className="steps">

			{logo}

			{/* STEP THREE ----------------------------------------------------------------------*/}
			<div
				className={( tab === 1 ? 'step step-active' : 'step' ) + ' enabled'}
				data-id="1"
				onClick={( e ) => this.setTab( e )}>

				<div className="step-circle">1</div>
				<h3>{tr( <span>Upload<br/>Video</span>, <span
					className="step-cn">上传<br/>视频</span> )}</h3>
			</div>


			{/* STEP TWO ------------------------------------------------------------------------*/}
			<div
				className={( tab === 2 ? 'step step-active' : 'step' ) + (videoSrc ? ' enabled' : '')}
				data-id="2"
				onClick={( e ) => this.setTab( e )}>

				<div className="step-circle">2</div>
				<h3>{tr( <span>Select<br/>Clip</span>, <span
					className="step-cn">截取<br/>片段</span> )}</h3>
			</div>


			{/* STEP THREE ----------------------------------------------------------------------*/}
			<div
				className={( tab === 3 ? 'step step-active' : 'step' ) + (gifSrc ? ' enabled' : '')}
				data-id="3"
				onClick={( e ) => this.setTab( e )}>

				<div className="step-circle">3</div>
				<h3>{tr( <span>Generate<br/>Gif</span>, <span
					className="step-cn">生成<br/>GIF</span> )}</h3>
			</div>
		</div>;


		// DEFAULT CONTENT UPLOAD TAB
		// -----------------------------------------------------------------------------------------
		upload = <article id="uploadPanel" className="upload"
						  onDragOver={this.preventDefault}
						  onDrop={( e ) => this.filesDropped( e )}
						  onDragEnter={( e ) => this.inBounds( e )}
						  onDragLeave={( e ) => this.outOfBounds( e )}
						  onDragEnd={( e ) => this.outOfBounds( e )}>
			<div className={inBounds ? 'drop-zone drop-zone-active' : 'drop-zone'}>
				<article className="drop-zone-inner">
					<div>


						{/* CHECK FOR ERROR MESSAGES --------------------------------------------*/}
						{(function () {
							if ( error )
								return <article>
									<h2>{tr( 'Uh Oh!', '呃，好像有点问题' )}</h2>
									<h3>{error}</h3>
								</article>;

							else return <article
								className={inBounds ? 'article-grow' : ''}>
								<h2>{inBounds
									? tr( 'Drop it like it\'s hot!', '拖拽...瞄准...投放！' )
									: ( checkMobile() ? tr( 'Let\'s get started', '准备开始(・ω・)' ) : tr( 'Drag & Drop Here!', '拖拽视频上传' ) )}
								</h2>

								<h3/>
							</article>

						})()}

						<div
							className={inBounds ? 'btn btn-exit-bottom' : 'btn btn-gold'}>

							<input id="fileLoader" type="file"
								   accept="video/*"
								   onChange={( e ) => this.loadVideo( e )}/>

							{tr( 'Select Video', '选择视频' )}
						</div>
					</div>
				</article>
			</div>
		</article>;


		// DEPENDING ON TAB SELECTED SHOW CONTENT
		// -----------------------------------------------------------------------------------------
		if ( tab !== 1 && !error ) {
			if ( videoSrc && tab === 2 ) video =
				<VideoComponent App={this} generateGif={this.generateGif}/>;

			if ( gifSrc && tab === 3 ) result =
				<ResultComponent App={this}/>;
		}


		// RETURN DOM
		// -----------------------------------------------------------------------------------------
		return (
			<div className="App" style={tab === 3 ? {
				background: 'url(' + burstBackground + ') no-repeat center',
				backgroundSize: 'cover'
			} : {}}>

				{/* IF NO MOBILE OR IS MOBILE AND FIRST TAB SHOW LANG SELECT */}
				{!showWeChatSplash && ( !checkMobile() || tab === 1 ) ?
					<div className="lang" onClick={( e ) => this.changeLanguage()}>
						<p>{checkMobile() ? tr( '切换到中文版的动次', 'Switch to English' ) : tr( '中文', 'EN' )}</p>
					</div> : null}

				<form className="Options">


					{/* HEADER SECTION ----------------------------------------------------------*/}
					{header}


					{/* MAIN CONTENT SECTION ----------------------------------------------------*/}
					{result || video || upload}


					{/* SPLASH SCREEN WELCOME / MOBILE SHADE ------------------------------------*/}
					{splash ? splash : null}


					{/* WE CHAT QR CODE SHADE ---------------------------------------------------*/}
					{state.showWechatQR ? <WechatQRComponent App={this}/> : null}
				</form>


				{/* FOOTER SECTION --------------------------------------------------------------*/}
				{!checkMobile() || tab === 1 || tab === 3 ? <footer>

					{/* ICP */}
					<small>沪ICP备13026416号-2</small>
					&nbsp;|&nbsp;

					{/* KAWO LINK */}
					<small><a target="_blank" href="http://www.kawo.com">KAWO</a></small>
					&nbsp;|&nbsp;

					{/* WECHAT SHARE */}
					<small><a
						onClick={( e ) => this.setState( prevState => ({ showWechatQR: true }) )}>{tr( 'WeChat', '微信' )}</a>
					</small>
					&nbsp;|&nbsp;

					{/* WEIBO SHARE */}
					<small><a target="_blank"
							  href="http://weibo.com/kawosocial">{tr( 'Weibo', '微博' )}</a></small>
					&nbsp;|&nbsp;

					{/* FACEBOOK SHARE */}
					<small><a target="_blank"
							  href="https://www.facebook.com/kawo.official">Facebook</a></small>
				</footer> : null}
			</div>
		);
	}


	// NEED THIS TO ACTUALLY PREVENT DEFAULT BEHAVIOUR. THIS IS DUE TO A BUG IN CHROME
	// =============================================================================================
	preventDefault( e ) {
		e.preventDefault();
	}


	// METHOD THAT HANDLES THE UPLOAD BUTTON INPUT AND DROP AREA
	// =============================================================================================
	filesDropped( e ) {
		e.preventDefault();

		// RESET DRAG COUNTER FOR CHECKING INSIDE BOUNDS WHEN DRAGGING FILE TO DROPZONE
		this.dragCounter = 0;

		// RESET CHECK FOR INSIDE DROP ZONE
		this.setState( prevState => ({ inDropBounds: false }) );

		// GET THE DATA TRANSFER OBJECT FROM THE EVENT, BUTTON USES e, DROP ZONE USES e.originalEvent
		let dt = e.dataTransfer || e.originalEvent.dataTransfer,
			data = dt || e.target,
			files = data.items || data.files;

		// MAKE SURE WE HAVE FILES
		if ( files && files.length ) {

			window.mixpanel.track( 'Upload', {
				app: 'video-to-gif',
				action: 'dropped',
				numImages: files.length
			} );


			// USE DATA TRANSFER ITEM LIST INTERFACE TO ACCESS THE FILE(S)
			// -------------------------------------------------------------------------------------
			for ( let i = 0; i < files.length; i++ ) {

				// getAsFile IS USED BY THE DROP API, OTHERWISE BUTTON WAS CLICKED
				let file = files[ i ].name ? files[ i ] : files[ i ].getAsFile();

				this.loadVideo( file );
			}
		}
	}


	// LOADS A VIDEO FROM A LOCAL DRIVE AND PLAYS THAT FILE
	// =============================================================================================
	loadVideo( e ) {
		let $this = this,
			orientationMatrix,
			file,
			fileError,
			fileErrorMsg;


		// RESET ANY STATE AND APPLY NEW VIDEO INFO TO CURRENT STATE
		// -----------------------------------------------------------------------------------------
		if ( $this.state.videoSource ) $this.state = $this.initialState;

		if ( e && e.target ) {
			e.preventDefault();

			// GET VIDEO FILE OBJECT
			file = e.target.files[ 0 ]

		} else file = e;


		// GENERATE THE VIDEO SOURCE FROM THE FILE OBJECT
		// -----------------------------------------------------------------------------------------
		if( typeof file.toString === 'function' && file.toString() === '[object File]' )
			src = ( window.URL || window.webkitURL ).createObjectURL( file );

		else {
			let binaryData = [];

			binaryData.push( file );

			src = ( window.URL || window.webkitURL ).createObjectURL( new Blob( binaryData, { type: 'video' } ) );
		}


		// CHECK FOR ERRORS, NOT A SUPPORTED VIDEO
		// -----------------------------------------------------------------------------------------
		if ( file && !(/.mp4|.webm|.mov|.ogg|.mkv|.quicktime|.m4v/.test( file.type ) ) ) {
			let fileExtension = /(?:\.([^.]+))?$/.exec( file.name )[1];

			fileError = 'Unsupported Format';
			fileErrorMsg = tr( 'Sorry, ' + fileExtension + ' format is not supported.',
				'抱歉，暂时不支持' + fileExtension + '格式' );
		}


		// SET UP VIDEO AND VIDEO LOADED CALLBACK
		// -----------------------------------------------------------------------------------------
		let video = document.createElement( 'video' ),
			videoSize = String( ( file.size / 1024 / 1024 ).toFixed( 2 ) ),
			checkVideo = function ( e ) {


				// CHECK FOR VIDEO ERRORS
				// ---------------------------------------------------------------------------------
				let videoErrorMsg = false, videoError = false;

				// VIDEO IS LONGER THAN 5 MINS
				if ( video.duration > 60 * 5 ) {
					videoError = 'Max duration hit';
					videoErrorMsg = tr( 'Sorry, videos over 5 minutes are not supported.',
						'视频太大了QAQ，先剪辑一下，不要超过5分钟哦' );
				}

				// VIDEO'S DIMENSIONS AND THUS SIZE WILL BE TOO LARGE FOR CANVAS TO HANDLE EASILY
				if ( video.videoWidth * video.videoHeight > 2211840 ) {
					videoError = 'Max size hit';
					videoErrorMsg = tr( 'Sorry, this video is too large. Highest accepted resolution is 1080 x 720.',
						'哇，超清，狗眼烧坏啦(⊙o⊙)。我们支持的最高像素为1080 x 720' );
				}

				// VIDEO'S DIMENSIONS AND THUS SIZE WILL BE TOO LARGE FOR CANVAS TO HANDLE EASILY
				if ( video.videoWidth < 1 || video.videoHeight < 1 ) {
					videoError = 'Invalid Width/Height';
					videoErrorMsg = tr( 'Sorry, there seems to be a problem processing this video.',
						'' );
				}

				$this.setState({
					error: videoErrorMsg,
					fileType: file.type,
					videoSource: videoErrorMsg ? false : src,
					tab: videoErrorMsg ? $this.state.tab : 2,
					videoFileSize: videoSize,
					videoName: file.name.replace( /.mp4|.webm|.mov|.ogg|.mkv|.quicktime|.m4v/, '' )
				});

				video.removeEventListener( e.type, checkVideo );

				if ( videoError ) window.mixpanel.track( 'Upload', {
					app: 'video-to-gif',
					action: 'image-uploaded-error',
					fileName: file.name,
					fileType: file.type,
					fileSize: videoSize,
					fileError: videoError
				});

				else window.mixpanel.track( 'Upload', {
					app: 'video-to-gif',
					action: 'image-uploaded-success',
					fileName: file && file.name,
					fileType: file && file.type,
					fileSize: videoSize,
				});
			};


		// FILE ERROR FOUND, DISPLAY MESSAGE
		// -----------------------------------------------------------------------------------------
		if ( fileError ) {
			window.mixpanel.track( 'Upload', {
				app: 'video-to-gif',
				action: 'image-uploaded-error',
				fileName: file.name,
				fileType: file.type,
				fileSize: videoSize,
				fileError: fileError
			});

			this.setState( prevState => ({
				error: fileErrorMsg,
				fileType: file.type,
				videoName: file.name.replace( /.mp4|.webm|.mov|.ogg|.mkv|.quicktime|.m4v/, '' )
			}) )

		} else {

			/* TODO: ON XIUMIS BROWSER, the events loadstart is called then stalled. Stalled states that
				the media element suddenly stopped recieving data and based off the user agent a wait
				timeout has been reached (around 3 seconds). Manually trying to reload by calling video.load()
				returns the same results

				video.addEventListener( 'loadstart', console.log("SOMETHING") );
				video.addEventListener( 'stalled', console.log("SOMETHING") );
			*/


			// USE THE FILE READER TO FIND THE ORIENTATION MATRIX IN THE METADATA FOR QUICKTIME VIDEOS
			// -------------------------------------------------------------------------------------
			if ( file && /.quicktime/.test( file.type ) ) {
				let fileReader = new FileReader();

				fileReader.onload = function ( e ) {

					orientationMatrix = getDegrees( e.target.result );

					$this.setState( prevState => ({ orientationMatrix: orientationMatrix }), () => {

						video.addEventListener( 'durationchange', checkVideo );

						video.src = src;
					});
				};

				fileReader.readAsArrayBuffer( file );

			} else {

				video.addEventListener( 'durationchange', checkVideo );

				video.src = src;
			}

			window.mixpanel.track( 'Upload', {
				app: 'video-to-gif',
				action: 'image-uploaded',
				fileName: file && file.name,
				fileType: file && file.type,
				fileSize: videoSize,
				fileSource: src
			});
		}
	}


	// METHOD THAT SETS A HOVER STATE WHEN DRAGGIN IMAGES OVER DROP ZONE, MUST BE IN JS, DON'T WANT JUST ANY HOVER
	// =============================================================================================
	inBounds( e ) {
		e.preventDefault();

		this.dragCounter++;

		if ( !this.state.inDropBounds ) this.setState( prevState => ({ inDropBounds: true }) );
	}


	// METHOD THAT REMOVES A HOVER STATE WHEN DRAGGIN IMAGES OVER DROP ZONE, MUST BE IN JS, DON'T WANT JUST ANY HOVER
	// =============================================================================================
	outOfBounds( e ) {
		e.preventDefault();

		this.dragCounter--;

		// CHECK TO MAKE SURE TARGET IS NOT A CHILD OF THE DROP ZONE
		if ( this.state.inDropBounds && this.dragCounter === 0 ) this.setState( prevState => ({ inDropBounds: false }) );
	}


	// GENERATES A GIF FROM GIFSHOT
	// =============================================================================================
	generateGif( e ) {
		let state = this.state;

		e.preventDefault();

		// DON'T ALLOW TO CREATE A GIF WITH A WIDTH OR HEIGHT OF 0
		if ( state.canvasWidth < 1 || state.canvasWidth < 1 ) return false;

		window.mixpanel.track( 'Image', {
			app: 'video-to-gif',
			action: 'generate-gif',
			quality: state.imageQuality,
			duration: state.gifDuration,
			frames: state.images.length,
			gifWidth: state.canvasWidth,
			gifHeight: state.canvasHeight
		} );

		// SHOW LOADING STATE AND CREATE A LOADING MESSAGE
		this.setState( prevState => ({
			showSpinner: true
		}), () => {
			this.loadingMessage();
		});

		let $this = this,
			startTime = new Date().getTime(),
			createGif = function () {
				let state = $this.state;

				// CHECK AGAIN IN 1 SECOND IF WE CAN SAVE FRAMES
				if ( state.saveFrames )
					setTimeout( function () {
						createGif();
					}, 1000 );

				// CREATE THE GIF
				else gifshot.createGIF( {
					images: state.images,								// THE ARRAY OF IMAGES
					gifWidth: state.canvasWidth,						// FINAL GIF WIDTH
					gifHeight: state.canvasHeight,						// FINAL GIF HEIGHT
					numFrames: state.images.length,						// NUMBER OF PASSED FRAMES
					sampleInterval: state.sampleInterval,				// LEVEL OF QUANTIZATION AS INTEGER
					interval: ( 1 / state.frameRate ).toFixed( 2 ),		// DISPLAY LENGTH OF EACH FRAME IN SECONDS
					numWorkers: 5,										// NUMBER OF WEB WORKERS TO SPIN UP
					progressCallback: function ( progress ) {			// CALLBACK TO SET PROGRESS BAR

						document.getElementById( 'progress' ).style.width = ( progress * 100 ).toFixed() + '%';
					}

				// ON COMPLETE CALLBACK METHOD
				}, function ( obj ) {

					// UNSET SPINNER
					$this.setState( prevState => ({
						showSpinner: false
					}) );

					if ( !obj.error ) {
						let estimatedSize = 0;

						state.images.forEach( function ( img ) {

							let head = 'data:image/gif;base64,';

							estimatedSize += Math.round( (img.length - head.length) * 3 / 4 );
						});

						estimatedSize = ( estimatedSize / 1024 / 1024 / 2 ).toFixed( 2 );


						// GET NEW GIF'S TRUE FILE SIZE
						// -------------------------------------------------------------------------
						let byteLength = parseInt( ( obj.image ).replace( /=/g, "" ).length * 0.75 );

						window.mixpanel.track( 'Image', {
							app: 'video-to-gif',
							action: 'generate-gif-success',
							quality: state.imageQuality,
							timeToCreate: ( ( ( new Date().getTime() ) - startTime ) / 1000 ).toFixed(),
							duration: state.gifDuration,
							frames: state.images.length,
							size: String( ( byteLength / 1024 / 1024 ).toFixed( 2 ) ),
							estimatedSize: estimatedSize,
							gifWidth: $this.state.canvasWidth,
							gifHeight: $this.state.canvasHeight
						} );

						// SET THIS TO STATE AS MB
						$this.setState( prevState => ({
							trueGifSize: String( ( byteLength / 1024 / 1024 ).toFixed( 2 ) ),
							gifSource: obj.image,
							tab: 3
						}) );

					// TRACK ANY GIFSHOT ERRORS
					} else window.mixpanel.track( 'Image', {
						app: 'video-to-gif',
						action: 'generate-gif-error',
						quality: state.imageQuality,
						timeToCreate: ( ( ( new Date().getTime() ) - startTime ) / 1000 ).toFixed(),
						duration: state.gifDuration,
						frames: state.images.length,
						error: obj.errorMsg,
						errorCode: obj.errorCode,
						gifWidth: $this.state.canvasWidth,
						gifHeight: $this.state.canvasHeight
					} );
				} );
			};

		createGif();
	}


	// =============================================================================================
	loadingMessage() {
		let $this = this,
			message,
			number = Math.random().toFixed( 1 ) * 10;

		switch ( number ) {
			case 0:
				message = tr( 'Calling Taddy Mason...', '动次打次动次打次，苍茫的天涯是……' );
				break;
			case 1:
				message = tr( 'Are you still here...', '咻~唰~飞速滚动的进度条...' );
				break;
			case 2:
				message = tr( 'Please wait while little elves create your GIF...', '在普通的动次打次中普通地燃烧' );
				break;
			case 3:
				message = tr( 'Counting the 1\'s and 0\'s...', '黑科技正在动次动次地发功...' );
				break;
			case 4:
				message = tr( 'Don\'t think of purple hippos...', '我们的程序员小哥哥温柔帅气又呆萌(-ω-)' );
				break;
			case 5:
				message = tr( 'Creating randomly generated feature...', '喵星人万岁！侵略蓝星！称霸宇宙！' );
				break;
			case 6:
				message = tr( 'Does anyone actually read these?', '喵星人万岁！侵略蓝星！称霸宇宙！' );
				break;
			case 7:
				message = tr( 'Weighing the cat...', '看到这行字，说明你是动次选中的战士' );
				break;
			case 8:
				message = tr( 'Ensuring everything works perfektly...', '一切都是石头门的选择~El Psy Congroo' );
				break;
			case 9:
				message = tr( 'Please wait... Consulting the manual...', '听到吉他手滋儿一声之后，就开始疯狂地动次打次' );
				break;
			case 10:
				message = tr( 'Go ahead -- Hold your breath!', '你是猴子派来转视频的吗？' );
				break;
		}

		this.setState( prevState => ({
			loadingMessage: message
		}) );

		if ( this.state.showSpinner ) setTimeout( function () {
			$this.loadingMessage()
		}, 5000 )
	}


	// =============================================================================================
	setTab( e ) {
		let selected = Number( e.currentTarget.dataset.id );

		if ( selected !== 1 && ( !( this.state.videoSource && selected === 2 ) && !( this.state.gifSource && selected === 3 ) ) )
			return false;

		window.mixpanel.track( 'Navigate', {
			app: 'video-to-gif',
			action: 'tab-' + selected
		} );

		this.setState( prevState => ({ tab: selected }) )
	}


	// =============================================================================================
	changeLanguage() {

		// SET LANGUAGE TO WINDOW AND RE RENDER
		if ( window.userLanguage === 'CN' ) window.userLanguage = 'EN';

		else window.userLanguage = 'CN';

		window.mixpanel.track( 'Language Changed', {
			app: 'video-to-gif',
			action: window.userLanguage
		} );

		try {
			localStorage.setItem( 'userLanguage', window.userLanguage );
		} catch ( e ) {}

		this.forceUpdate();
	}
}

export default App;


// WEBPACK FOOTER //
// ./src/app/scenes/App.js